import Submenu from "../../components/organisms/Submenu";

import { Links } from "./Links";
import { Agenda } from "./Agenda";
import { Signatures } from "./Signatures";
import { Support } from "./Support";
import { Profile } from "./Profile";
import { Management } from "./Management";
import { Sales } from "./Sales";
import { Configurations } from "./Configurations";
import { controllerHub } from "../../services/controllers/hub";
import { Notifications } from "./Notifications";
import BasePage from "../basePage";
import { LayoutTemplate } from "lucide-react";

export function Hub() {
  controllerHub()

  return (
    <BasePage pageTitle={<><LayoutTemplate className='w-7 h-7' />Hub</>}>
      <div className="w-full grid gap-4 p-2 pr-4 flex-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 sm:auto-rows-[calc(((100vw/12)-(1rem*1)))] lg:auto-rows-[calc(((100vw/7)-(1rem*5)))] xl:auto-rows-[2rem] grid-flow-row-dense pb-14">
        <Agenda />
        <Signatures />
        <Profile />
        <Support />
        <Notifications />
        <Sales />
        <Links />
        <Management />
        <Configurations />
      </div>
    </BasePage >
  );
}
